import React, { useRef, useState, useEffect, Suspense, Fragment } from "react";
import ShimmerLoader from "../ShimmerLoader";

const VarintProtienDist = React.lazy(() => import("."));

function VarinatAndProteinDistrubutionLazyLoadWrapper(props) {
  const {
    Fullscreen,
    Highcharts,
    fromDate,
    toDate,
    proteinChangeDetails,
    variantTypeTotal,
    variantTypeResponse,
    varianttype
  } = props;

  const containerRef = useRef();
  const hasTriggeredApi = useRef(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasTriggeredApi.current) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 0.1,
      }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }
    return () => observer.disconnect();
  }, []);

  return (
    <Fragment>
      <div ref={containerRef}>
        {isVisible && (
          <Suspense fallback={<ShimmerLoader />}>
            <VarintProtienDist
              Fullscreen={Fullscreen}
              Highcharts={Highcharts}
              fromDate={fromDate}
              toDate={toDate}
               proteinChangeDetails={proteinChangeDetails}
              variantTypeTotal={variantTypeTotal}
              variantTypeResponse={variantTypeResponse}
               varianttype={varianttype}
            />
          </Suspense>
        )}
      </div>
    </Fragment>
  );
}

export default VarinatAndProteinDistrubutionLazyLoadWrapper;
